import { render, staticRenderFns } from "./DailyReportDate.vue?vue&type=template&id=87c866e2&"
import script from "./DailyReportDate.vue?vue&type=script&lang=ts&"
export * from "./DailyReportDate.vue?vue&type=script&lang=ts&"
import style0 from "./DailyReportDate.vue?vue&type=style&index=0&id=87c866e2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports